import './About.scss';

import {Button} from "./Reusable"
import VideoEmbed from './VideoEmbed'
import reelPoster from '../resources/images/reel-poster.webp'

function About() {

    const youtubeID = "yuziqwtTI-c"

    return (
        <>
            <div className="About" id="about">
                <div className="About-container reveal">
                    <h2>Candle<b>lyte</b></h2>
                    <p>a Minnesota-based video production company founded on the belief that any vision worth sharing should be shared beautifully.</p>
                    <br />
                    <br />
                    {/* the founder door used to be a text link here — it's the
                        FounderPreview block directly below now */}
                    <Button title="Take Action" flameon={true} source="About section" />
                </div>
                {/* wrapper carries the layout + reveal; VideoEmbed holds the
                    16:9 box and only mounts the real iframe once it's clicked */}
                <div className="About-video reveal delay-1">
                    <VideoEmbed
                        youtubeID={youtubeID}
                        poster={reelPoster}
                        title="Candlelyte Productions highlight reel"
                        label="Watch the reel"
                        name="Highlight reel" />
                </div>
            </div>
        </>
    );
}

export default About;